import { render, staticRenderFns } from "./AttachmentManagement.vue?vue&type=template&id=764cc880&scoped=true&"
import script from "./AttachmentManagement.vue?vue&type=script&lang=js&"
export * from "./AttachmentManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764cc880",
  null
  
)

export default component.exports